import React from 'react'

import clsx from 'clsx'
import { useRouter } from 'next/router'

import Typography from 'components/Typography'
import { useAppContext } from 'context/AppContext'
import { useEventContext } from 'context/EventContext'
import { revealSEOUrl } from 'helpers/SEOHelper'
import usePagination from 'hooks/usePagination'
import useViewport from 'hooks/useViewport'

import PaginationItem from './components/PaginationItem'

import classes from './Pagination.module.scss'

const noop = () => {}

/** @type {import("./types").default} */
const Pagination = ({ pagination, spa = false, className = '' }) => {
  const { is } = useViewport()
  const eventContext = useEventContext()
  const { route } = useAppContext()
  const router = useRouter()

  const { items } = usePagination({
    page: pagination.page,
    count: pagination.num_pages,
    siblingCount: is('xs') ? 1 : 2,
  })

  if (pagination.num_pages === 1) {
    return null
  }

  const renderItem = ({ index, ...item }) => {
    const url =
      item.page === 1 ? pagination.first_page : revealSEOUrl(pagination.other_page_pattern.replace(/PAGE/, item.page))

    const hasLink = !item.disabled && item.page
    const isSemPage = url.includes('/p/sem/')
    const isSerpPage = route?.includes('serp_category')

    const handleClickAsSpa = event => {
      // Fixes scroll issues with firefox and safari
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      }, 0)
      event.preventDefault()

      router.push(url)
    }

    const disabledItemProps = {
      ...item,
      onClick: noop,
    }

    return hasLink ? (
      <a
        className={classes.link}
        href={url}
        {...eventContext.addEvent({
          engagementComponent: isSerpPage ? 'serp-pagination' : 'pagination',
          engagementDestination: 'change-page',
          engagementDetails: isSemPage && item.type == 'page' ? item.page : 'pagination-button',
          name: isSerpPage ? 'engagement_navigation' : 'engagement_pagination',
        })}
        key={index}
        onClick={spa ? handleClickAsSpa : undefined}
      >
        <PaginationItem {...item} />
      </a>
    ) : (
      <PaginationItem key={index} {...disabledItemProps} disabled />
    )
  }

  return (
    <div className={clsx('Pagination', classes.root, className)}>
      <div className={classes.pagination}>
        {items.map((item, index) =>
          renderItem({
            ...item,
            color: 'primary',
            shape: 'rounded',
            size: is('xs') ? 'small' : 'large',
            index,
          })
        )}
      </div>

      <Typography
        className={classes.typhography}
        variant="body-sm"
      >{`page ${pagination.page} of ${pagination.num_pages}`}</Typography>
    </div>
  )
}

export default Pagination
